<script>
    import { faPlus } from "@fortawesome/free-solid-svg-icons";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../../ui/Button.svelte";
    import ButtonAdd from "../../ui/ButtonAdd.svelte";
    import NumberInput from "../../ui/NumberInput.svelte";
    import { v4 as uuidv4 } from 'uuid';


    export let max_stamp_count;

    const dispatch = createEventDispatcher();

    const default_milestone = {
        stamp_count: max_stamp_count,
        type: "all",
        rewards: []
    }

    let milestone = {...default_milestone};

    function confirm() {
        milestone.id = uuidv4();
        dispatch("add", milestone);
        milestone = {...default_milestone};
        open = false;
    }

    function cancel() {
        open = false;
    }

    let open = false;
</script>

<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Meilenstein hinzufügen</DialogTitle>
        <DialogDescription class="dialog-description">
            Lege einen Meilenstein fest. Beim Erreichen des Stempelziels erhalten deine Kunden die von dir angegebene Belohnung.
        </DialogDescription>
        
        <form on:submit|preventDefault={confirm}>
            <NumberInput
                label = "Stempelziel"
                bind:value={milestone.stamp_count}
                min = 1
                max = {max_stamp_count}
            />
            <label>
                <input type=radio bind:group={milestone.type} value={"all"}>
                Der Gast erhält alle angegebenen Belohnungen.
            </label>
            <label>
                <input type=radio bind:group={milestone.type} value={"choice"}>
                Der Gast sucht sich eine der angegebenen Belohnungen aus.
            </label>

            <div class="dialog-options">
                <Button type="button" on:click={cancel}>
                    Abbrechen
                </Button>
                <Button type="submit" intent="primary">
                    Hinzufügen
                </Button>
            </div>
        </form>
    </div>
</Dialog>

<ButtonAdd on:click={() => {open = true}}>
    <Fa icon={faPlus} slot="icon"/>
</ButtonAdd>